/**
 * Dependency-free JSON.parse helper for untrusted persisted/native-callback
 * strings (AsyncStorage values, Bluetooth/print bridge payloads). Values can
 * be empty/whitespace-only or truncated (e.g. app killed mid-write on
 * low-end Android devices) — an unguarded `JSON.parse()` on those throws
 * "Unexpected end of input" from inside async native-callback code paths
 * (Bluetooth print flows), surfacing in Sentry as an uncaught "tryCallOne"
 * crash. This never throws: it returns `fallback` on any empty/invalid input.
 * @param {string|null|undefined} raw - Raw stored/received string.
 * @param {*} [fallback=null] - Value to return when parsing fails.
 * @returns {*} Parsed value, or `fallback` when `raw` is empty/invalid JSON.
 */
export const safeJsonParse = (raw, fallback = null) => {
    if (!raw || typeof raw !== 'string' || !raw.trim()) {
        return fallback;
    }
    try {
        return JSON.parse(raw);
    } catch (error) {
        console.error('Error parsing JSON value:', error);
        return fallback;
    }
};

export default safeJsonParse;
